import { useQuery } from "react-query";
import authAPI from "../authAPI";

export const useGroupMembers = (groupId, options = {}) => {
  return useQuery(
    ["groupMembers", groupId],
    async () => {
      const result = await authAPI.getGroupMembers(groupId);
      return result;
    },
    {
      enabled: !!groupId,
      ...options,
    }
  );
};
